<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { AppState, ToastQueue } from '../../etc/stores';
  import { copyTextToClipboard } from '../../etc/utils';
  import { replaceVariables } from '../../i18n';
  import Check from '../icons/Check.svelte';
  import Button from '../form/Button.svelte';
  import Text from '../typography/Text.svelte';

  export let code: string = '';
  export let disabled: boolean = false;

  const { primary200 } = $AppState.theme.colors;
  const dispatch = createEventDispatcher();

  let copied = false;

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`convert_coins.${text}`), values);
  };

  export const onCopy = (showSuccess = true) => {
    copied = true;

    copyTextToClipboard(code);

    if (showSuccess)
      ToastQueue.add({
        title: t('copied_success.title'),
        message: t('copied_success.message'),
        type: 'success',
        duration: 10500
      });

    dispatch('copy');

    setTimeout(() => {
      copied = false;
    }, 5000);
  };
</script>

<div
  class="twism-copy-box {$$props.class || ''}"
  class:--disabled={disabled}
  on:click={onCopy}
>
  <slot>
    <Text class="twism-copy-box__text" type="medium" bold color={primary200}>
      {code}
    </Text>
  </slot>
  {#if copied || disabled}
    <Button schema="green">
      <div class="twism-copy-box__check">
        <Check size={16} stroke="#FFF" />
      </div>
      Copied!
    </Button>
  {:else}
    <Button>Copy</Button>
  {/if}
</div>

<style lang="scss">
  .twism-copy-box {
    padding: 8px 12px;
    background: var(--twism-theme-primary600);
    border: 1px dashed var(--twism-theme-primary400);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    :global(button) {
      min-width: 72px;
      width: auto;
      padding: 4px 8px;
      height: 32px;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.01em;
    }
    :global(.twism-green) {
      background-color: #1ea961;
    }
    :global(.twism-green:hover) {
      background-color: #1ea961;
    }

    :global(.twism-button-content) {
      position: relative;
    }

    &.--disabled {
      pointer-events: none;
      opacity: 0.30;
    }

    @keyframes copy-sucess {
      from {
        width: 0px;
        opacity: 0;
      }
      to {
        width: 24px;
        opacity: 1;
      }
    }

    &__check {
      width: 24px;
      display: flex;
      align-items: center;
      animation-name: copy-sucess;
      animation-duration: 500ms;
      animation-timing-function: ease-in;
    }
  }
</style>
